module.exports = "<app-nav></app-nav>\n<br><br>\n<mat-card class=\"container\"> \n  <div class=\"subcontainer\">\n      <flash-messages></flash-messages>\n      <router-outlet></router-outlet>\n  </div>\n\n</mat-card>\n<br><br><br><br><br>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/meeting/meeting.component.html
// module id = ./src/app/components/meeting/meeting.component.html
// module chunks = main